module.exports = __webpack_public_path__ + "img/modal_bg.aaf9b8db.png";